import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONTRATOS_URL}${process.env.VUE_APP_API_PATH}/contratos`

export default {
    obterProcessoGedocPorNumero(numeroprocesso) {
        return axiosJwt
            .get(
                `${api}/precontrato/obterprocessogedocpornumero/${numeroprocesso}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterProcessosPorNumeroAta(numeroAta) {
        return axiosJwt
            .get(
                `${api}/precontrato/obterprocessosatapornumeroata/${numeroAta}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedorCpfCnpj(cnpjcpf) {
        return axiosJwt
            .get(`${api}/precontrato/obterfornecedor/${cnpjcpf}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedorCod(cod) {
        return axiosJwt
            .get(`${api}/precontrato/obterfornecedor/estrangeiro/${cod}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPreContrato(preContrato) {
        return axiosJwt
            .post(`${api}/precontrato`, preContrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarPreContrato(preContrato) {
        return axiosJwt
            .put(`${api}/precontrato`, preContrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(contratoId) {
        return axiosJwt
            .get(`${api}/precontrato/${contratoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirItemContrato(itemContrato) {
        return axiosJwt
            .post(`${api}/precontrato/inseriritemcontrato`, itemContrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarItemContrato(itemContrato) {
        return axiosJwt
            .put(`${api}/precontrato/atualizaitemcontrato`, itemContrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItensContrato(contratoId) {
        return axiosJwt
            .get(`${api}/precontrato/obteritenscontrato/${contratoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    removerItemContrato(contratoId, itemContratoId) {
        return axiosJwt
            .delete(
                `${api}/precontrato/removeritemcontrato/${contratoId}/${itemContratoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirSubItemContrato(subIemContrato) {
        return axiosJwt
            .post(`${api}/precontrato/inserirsubitemcontrato`, subIemContrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarSubItemContrato(subIemContrato) {
        return axiosJwt
            .put(`${api}/precontrato/atualizarsubitemcontrato`, subIemContrato)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    removerSubItemContrato(contratoId, itemContratoId, idItemReferencia) {
        return axiosJwt
            .delete(
                `${api}/precontrato/removersubitemcontrato/${contratoId}/${itemContratoId}/${idItemReferencia}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterSubItensContrato(contratoId, itemContratoId) {
        return axiosJwt
            .get(
                `${api}/precontrato/obtersubitenscontrato/${contratoId}/${itemContratoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirSubItensArquivo(subItem) {
        const formData = new FormData()
        formData.append('idContrato', subItem.idContrato)
        formData.append('idItemReferencia', subItem.idItemReferencia)
        formData.append('arquivo', subItem.arquivo)
        let promisse = axiosJwt.post(
            `${api}/precontrato/inserirsubitensarquivo`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
